import React from "react";

function Flag({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 47.108 139.499" className={className}>
      <rect height="114" y="0" transform="translate(0 25.499)" width="2" />
      <g transform="translate(-703 -451.489)">
        <path
          d="M2.546.675a12.353,12.353,0,0,1,7.195-1.9c5.55.43,13.9,3.471,20.453,3.471C40.7,2.247,44.562.675,44.562.675a2.85,2.85,0,0,1,2.546,3.077v20a2.85,2.85,0,0,1-2.546,3.077,49.405,49.405,0,0,1-14.367,1.445A94.571,94.571,0,0,1,8.951,23.753c-3.547-1.28-6.4,3.077-6.4,3.077A2.85,2.85,0,0,1,0,23.753v-20A2.85,2.85,0,0,1,2.546.675Z"
          transform="translate(703 452.742)"
        />
      </g>
    </svg>
  );
}

export { Flag };
